import Vue from "vue";

const success = (context, response) => {
  if (response.data.errors && response.data.errors.length > 0) {
    response.data.errors.map((error) => {
      toastr.error(error);
    });
  } else {
    toastr.success(response.data.msg);
  }
  context.closeEditPriceModal();
  context.smallLoading = false;
  context.closeModal("#edit-rentals-price");
  context.priceToEdit = {};
  context.isUpdatedValue = true;
  context.enableOpenModal = false;
  context.enableMultipleModification = false;
  context.disabledCheckbox = false;
};

const failed = (context, error) => {
  context.closePanelOverlay();
  context.smallLoading = false;
  context.showToasterError(error);
  context.closeModal("#edit-rentals-price");
  context.priceToEdit = {};
  context.isUpdatedValue = true;
  context.enableOpenModal = false;
  context.enableMultipleModification = false;
  context.disabledCheckbox = false;
};

export default (context, data) => {
  return Vue.$http
    .post("/update-rental-price", data)
    .then((response) => {
      if (response && response.status === 200) {
        success(context, response);
      }
    })
    .catch((error) => {
      failed(context, error);
    });
};



// WEBPACK FOOTER //
// ./src/app/services/booking-com/updateRentalPrice.js